module.exports = __webpack_public_path__ + "static/media/UY.ac647a64.png";